// (B) 공구/매거진 FOCAS 진단 - 순수 로직/포맷. eqpDiscovery.js와 같은 이유로 컴포넌트와 분리.

export const STATUS_LABEL = {
  REQUESTED: '요청됨',
  RUNNING: '진단 중',
  DONE: '완료',
  FAILED: '실패',
  EXPIRED: '만료됨(에이전트 응답 없음)',
};

export const STATUS_COLOR = {
  REQUESTED: 'default',
  RUNNING: 'info',
  DONE: 'success',
  FAILED: 'error',
  EXPIRED: 'warning',
};

export const isPolling = (status) => status === 'REQUESTED' || status === 'RUNNING';

// report의 각 probe 항목을 "라벨/결과" 행으로 펼친다 - 화면 표용. 배열(macros/toolOffsets/pmc)은 각각 여러 행.
export const flattenReportRows = (report) => {
  if (!report) return [];
  const rows = [];
  const pushSingle = (label, item) => {
    if (!item) return;
    rows.push({
      label,
      ok: item.ok,
      detail: item.ok ? describeValue(item.value) : (item.error || '실패'),
    });
  };
  pushSingle('연결', report.connect);
  pushSingle('장비 정보(sysinfo)', report.sysinfo);
  pushSingle('운전 상태(statinfo)', report.statinfo);
  pushSingle('현재 공구 번호', report.currentTool);
  pushSingle('공구수명 - 그룹 ID', report.toolLifeGroupId);
  pushSingle('공구수명 - 수명 데이터', report.toolLifeLife);
  pushSingle('공구수명 - 현재 수', report.toolLifeCount);
  (report.macros || []).forEach((m) => rows.push({
    label: `매크로 #${m.no}`, ok: m.ok, detail: m.ok ? describeValue(m.value) : (m.error || '실패'),
  }));
  (report.toolOffsets || []).forEach((o) => rows.push({
    label: `공구 옵셋 ${o.no}번(타입 ${o.type})`, ok: o.ok, detail: o.ok ? describeValue(o.value) : (o.error || '실패'),
  }));
  (report.pmc || []).forEach((p) => rows.push({
    label: `PMC ${p.area}영역 ${p.start}~${p.end}`, ok: p.ok,
    detail: p.ok ? (p.rawHex ? `0x${p.rawHex}` : '-') : (p.error || '실패'),
  }));
  return rows;
};

const describeValue = (value) => {
  if (value == null) return '값 없음';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

// ============================= 매거진 위치 찾기 스캔(2026-10-17) =============================

// "매거진 위치 찾기" 버튼이 보내는 고정 파라미터 - 공구 정보 진단 탭의 두 번째 버튼용.
// macroRanges: #500~#999(비휘발성 공통변수 표준 구간) + #1000~#1199(일부 빌더가 그 다음 구간까지
// 확장해 ATC/매거진 데이터를 저장하는 경우가 있어 예비로 포함). pmcRanges: D0~D1999(PMC D영역 전체를
// 훑어 ATC 포트 테이블 후보를 찾는다). 공구수명 그룹/수명 데이터도 참고용으로 같이 읽는다.
export const buildScanParams = () => ({
  macroRanges: [
    { start: 500, end: 999 },
    { start: 1000, end: 1199 },
  ],
  pmcRanges: [{ area: 'D', start: 0, end: 1999 }],
  toolLife: true,
});

// 매크로 스캔 결과 중 "값이 있는"(null도 아니고 0도 아닌) 항목만 추려 "#번호=값" 문자열로.
// 매거진을 찾을 때 수백~수천 개 매크로를 한 번에 보고받으면 대부분 비어 있어(값 없음/0), 그걸 다
// 보여주면 찾던 몇 개가 묻힌다.
export const summarizeScanMacros = (macros) => {
  if (!Array.isArray(macros)) return [];
  return macros
    .filter((m) => m?.ok && m.value != null && m.value !== 0)
    .map((m) => `#${m.no}=${m.value}`);
};

// PMC 스캔 결과(청크 목록, rawHex) 중 0이 아닌 바이트만 "영역+주소=값"으로.
export const summarizeScanPmc = (pmcChunks) => {
  if (!Array.isArray(pmcChunks)) return [];
  const out = [];
  pmcChunks.forEach((chunk) => {
    if (!chunk?.ok || !chunk.rawHex) return;
    const bytes = chunk.rawHex.match(/.{1,2}/g) || [];
    bytes.forEach((hex, idx) => {
      const value = parseInt(hex, 16);
      if (value) out.push(`${chunk.area}${chunk.start + idx}=${value}`);
    });
  });
  return out;
};
